import { createChannel, Channel } from "./channel";
import { Message } from "./message";

export interface Bus {
  open<TChannel extends Channel>(
    id: string,
    channel?: TChannel,
  ): TChannel;

  channel<TChannel extends Channel>(
    id: string,
  ): TChannel | undefined;

  publish: <TMessage extends Message>(message: TMessage) => Promise<void> | void;
}

class BusImpl implements Bus {
  private channels_ = new Map<string, Channel>();

  open<TMessage extends Message, TChannel extends Channel<TMessage> = Channel<TMessage>>(
    id: string,
    channel?: TChannel,
  ): TChannel {
    let newChannel = channel;
    if (!newChannel) {
      newChannel = createChannel<TMessage>() as unknown as TChannel;
    }
    this.channels_.set(id, newChannel as unknown as Channel<Message>);

    newChannel.once("close", () => {
      this.channels_.delete(id);
    });

    return newChannel;
  }

  channel<TMessage extends Message, TChannel extends Channel<TMessage> = Channel<TMessage>>(
    id: string,
  ) {
    return this.channels_.has(id)
      ? this.channels_.get(id) as TChannel
      : undefined;
  }

  async publish<TMessage extends Message = Message>(message: TMessage) {
    const channels = [...this.channels_.values()];

    await Promise.all(channels.map((channel) => channel.publish(message)));
  }
}

export class DefaultBus extends BusImpl { }

export const createBus = () => new DefaultBus();
